function login_register_response(target, popup_contents = null) {
    if (popup_contents != null && popup_contents.hasOwnProperty('prepend')) {
        $('#popup-login-register .content h1').after(popup_contents.prepend);
    }

    $('#popup-login-register').data('origin', target);
}

export {login_register_response};